/*
 * Copyright(c) 1995 - 2020 T-Systems Multimedia Solutions GmbH
 * Riesaer Str. 5, 01129 Dresden
 * All rights reserved.
 */

import { Directive, Host, HostBinding, OnDestroy, OnInit, Optional } from '@angular/core';
import { Subscription } from 'rxjs';
import { TooltipDirective } from './tooltip.directive';

/**
 * This directive renders an "i" icon on the right top corner of the host element.
 * Used mainly in pair with button component.
 *
 * Along with TooltipDirective icon visibility will be controlled by disabled$ property in the TooltipDirective.
 */
@Directive({
    selector: 'commonTooltipIcon, [commonTooltipIcon]',
})
export class TooltipIconDirective implements OnInit, OnDestroy {
    @HostBinding('class.formTooltipIcon') visible = true;

    private subscription = new Subscription();

    constructor(
        @Optional() @Host() private tooltipDirective: TooltipDirective
    ) {
    }

    ngOnInit(): void {
        if (!this.tooltipDirective) {
            return;
        }
        this.subscription.add(
            this.tooltipDirective.disabled$.subscribe(disabled => this.visible = !disabled)
        )
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
